<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          has-return
          :has-save="currentTab.id != 'Tab1' || canSave"
          :page="currentTab.page"
          @onReturn="onReturn"
          @onSave="onSave"
        />

        <!-- <tab-header 
          :page="currentTab.page" 
          @display-invalid-tabs="setInvalidTabs" /> -->

        <div class="Sub-menu">
          <div class="shadow-bottom">
            <div class="w-100">
              <ul id="tabs" class="tab-list nav nav-pills mb-3" role="tablist">
                <li
                  v-for="tab in getTabs"
                  :key="tab.id"
                  class="nav-item-Sub-menu text-center"
                >
                  <a
                    class="nav-link"
                    :class="{ active: tab.isActive, disabled: tab.isDisabled }"
                    role="tab"
                    aria-selected="true"
                    aria-controls="tab-i"
                    @click="selectTab(tab)"
                  >
                    {{ tab.name }}

                    <i
                      v-if="tab.invalid"
                      class="far fa-exclamation-triangle warning"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="tab-content">
          <component
            :is="currentTab.id"
            ref="currenTab"
            v-bind="currentTab"
            @set-disability="setTabDisability"
            @set-visibility="setTabVisibility"
            @select-tab="selectTabById"
            @set-invalid-tabs="setInvalidTabs"
            @onChange="validateSaveButton"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab1 from './tabs/NonMileageServices';
import Tab2 from './tabs/ModifyMileageServices';
import Tab3 from './tabs/ModifyStartDateServices';
import TabHeader from './tabs/TabHeader';
import PageHeader from '@/components/common/page/PageHeader.vue';

export default {
  name: 'Master',
  components: {
    Tab1,
    Tab2,
    Tab3,
    TabHeader,
    PageHeader,
  },
  data: () => ({
    tabs: [
      {
        id: 'Tab1',
        name: 'Servicios sin Millaje',
        visibility: true,
        isDisabled: false,
        isActive: true,
        invalid: false,
        caption: 'I',
        page: {
          tabIndex: 1,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
      {
        id: 'Tab2',
        name: 'Modificar Millaje',
        visibility: false,
        isDisabled: false,
        isActive: false,
        invalid: false,
        caption: 'II',
        page: {
          tabIndex: 2,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
      {
        id: 'Tab3',
        name: 'Modificar Fecha Inicio de Servicio',
        visibility: false,
        isDisabled: false,
        isActive: false,
        invalid: false,
        caption: 'II',
        page: {
          tabIndex: 3,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
    ],
    canSave: false,
  }),
  computed: {
    getTabs() {
      return this.tabs.filter((t) => t.visibility);
    },
    currentTab() {
      return this.tabs.find((t) => t.isActive);
    },
  },
  mounted() {
    let listOfTabs = [1, 2, 3];
    this.setTabVisibility(listOfTabs, true);
  },
  methods: {
    onSave() {
      this.$refs.currenTab.onSave();
    },
    validateSaveButton() {
      if (this.currentTab.id === 'Tab3') {
        this.canSave = this.$refs.currenTab.items.length > 0;
      } else if (this.currentTab.id === 'Tab2') {
        this.canSave = !!this.$refs.currenTab.model.length > 0;
      }
    },
    selectTab(tab) {
      this.activateTab(tab);
    },
    selectTabById(tabNumber) {
      if (!tabNumber) return;

      const tab = this.getTabByNumber(tabNumber);
      if (!tab || (tab && tab.isActive)) return;

      this.activateTab(tab);
      return tab;
    },
    getTabByNumber(tabNumber) {
      return this.getTabs.find((t) => t.id === `Tab${tabNumber}`);
    },
    setTabVisibility(tabs, value) {
      value = value || true;
      this.tabs.map((s) => {
        const tabId = s.id;
        if (tabs.includes(parseInt(tabId.slice(tabId.length - 1)))) {
          s.visibility = value;
        }

        return s;
      });
    },
    setTabDisability(tabs, value) {
      value = value || false;
      tabs.forEach((tabNumber) => {
        const tab = this.getTabByNumber(tabNumber);
        if (!tab) return;

        tab.isDisabled = value;
      });
    },
    resetTabToValid() {
      this.tabs.forEach((tab) => {
        tab.invalid = false;
      });
    },
    async activateTab(tab) {
      if (tab.isActive || tab.isDisabled) return;

      const canLeavePage = await this.$store.dispatch('canLeavePage');
      if (!canLeavePage) return;

      this.currentTab.isActive = false;
      tab.isActive = true;
    },
    setInvalidTabs(tabNumberList, isInvalid) {
      tabNumberList = tabNumberList || [];
      isInvalid = isInvalid || false;

      this.resetTabToValid();
      tabNumberList.forEach((tabNumber) => {
        const tab = this.getTabByNumber(tabNumber);
        if (tab) {
          tab.invalid = isInvalid;
        }
      });
    },
    onReturn() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
#tabs {
  display: table;
  width: 100%;
  table-layout: fixed;
}
#tabs li {
  display: table-cell;
  cursor: pointer;
}
#tabs a {
  display: block;
  text-align: center;
}
ul.tab-list li > a.disabled {
  color: #e2e2e2;
}
i.warning {
  color: #ff5b5c;
  margin-left: 3px;
}
a.active i.warning {
  color: #fff;
}
</style>
